export default __webpack_public_path__ + "static/media/header-gift.20a32443.svg";